import { render } from "./Customer.vue?vue&type=template&id=699cf318&ts=true"
import script from "./Customer.vue?vue&type=script&lang=ts"
export * from "./Customer.vue?vue&type=script&lang=ts"

import "./Customer.vue?vue&type=style&index=0&id=699cf318&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Customer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "699cf318"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('699cf318', __exports__)) {
    console.log('reload')
    api.reload('699cf318', __exports__)
  }
  
  module.hot.accept("./Customer.vue?vue&type=template&id=699cf318&ts=true", () => {
    console.log('re-render')
    api.rerender('699cf318', render)
  })

}


export default __exports__